import { Box, Checkbox, FormControlLabel, Stack, TextField, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { DataTable } from "../../components/global/Table/DataTable"
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";
import { BarData } from "../../types";
import { SearchIcon } from "../../assets/svgs/SearchIcon";
import { FilterIcon } from "../../assets/svgs/FilterIcon";
import { FilterOffIcon } from "../../assets/svgs/FilterOffIcon";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'name',
    disablePadding: true,
    label: 'Name',
    align: 'left',
    sortable: true,
    searchable: true,
  },
  {
    id: 'is_supply',
    disablePadding: true,
    label: 'We Supply',
    width: '100px',
  },
];

interface BarTableData {
  id: any;
  name: any;
  is_supply: any;
}

export const ClientBars = () => {
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [bars, setBars] = useState<BarData[]>([]);
  const [rows, setRows] = useState<BarTableData[]>([]);
  const [showOnlySupply, setShowOnlySupply] = useState<boolean>(false);

  const refetchBars = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/bars/all');
    setBars(data ?? []);
    isLoading.current = false;
    setSIsLoading(false);
  }
  const getRows = (bars: BarData[]) => {
    const result: BarTableData[] = [];
    for (let i=0; i<bars.length; i++) {
      const bar = bars[i];
      if (showOnlySupply && !bar.is_supply) {
        continue;
      }

      result.push({
        id: `${bar.id}`,
        name: 
          <>
            <Typography style={{ margin: 0, color: bar.status ? 'inherit' : '#DCDCE0' }}>
              <span style={{fontSize: 18}}>{bar.name}</span>
              <br/>
              <span style={{fontSize: 15, fontStyle: 'italic'}}>{bar.address}</span>
            </Typography>
          </>,
        is_supply: 
          <>
            <Checkbox
              color="primary"
              checked={bar.is_supply}
              onChange={(e) => onAddtoSupplyList(e, bar, i)}
            />
          </>
      });
    }
    return result;
  }

  const submitSupply = async (bar: BarData, isSupply: boolean) => {
    let result = true;
    if (isSupply) {
      const { data, errors } = await fetchData('/client-bars/add',  { bar_id: bar.id }, 'POST');
      if (errors) result = false;
    } else {
      const { data, errors } =  await fetchData('/client-bars/delete',  { bar_id: bar.id }, 'POST');
      if (errors) result = false;
    }
    return result;
  }

  const onAddtoSupplyList = async (e: any, bar: BarData, barIndex: number) => {
    const checked = e.target.checked;
    if (await submitSupply(bar, checked)) {
      const newBar: BarData = { ...bar, is_supply: checked };
      const newBars = [...bars];
      newBars.splice(barIndex, 1, newBar);
      setBars(newBars);
    }
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchBars();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setRows(getRows(bars));
  }, [bars, showOnlySupply]);

  return (
    <Frame title="Locations">
      <Stack>
        <DataTable 
          headCells={headCells} 
          rows={rows} 
          isLoading={sIsLoading} 
          title="Locations"
          hideIdCheckbox={true}
          toolbarAdditionalRightElement={
            <Box style={{ width: "180px" }}>
              <FormControlLabel 
                control={<Checkbox />} 
                value={showOnlySupply} 
                label="We Supply"
                checked={showOnlySupply} 
                onChange={(e: any) => setShowOnlySupply(e.target.checked)}
              />
            </Box>
          }
        />
      </Stack>
    </Frame>
  )
}
